// const $ = require('jquery');
import $ from 'jquery';
const fs = require('datatables.net-plugins/sorting/file-size'); // eslint-disable-line

const hiddenColumns = ['1', '2', '3', '4'];
const titleColumn = 0;
const typeColumn = 1;
const departmentColumn = 2;
const categoryColumn = 3;
const yearColumn = 3;
const fileSizeColumn = 6;

const table = $('.js-search-documents').dataTable({
  "dom": 'ltip',
  "pageLength": 25,
  "columnDefs": [
    {
      "targets": hiddenColumns,
      "visible": false,
      "searchable": true
    },
    { type: 'file-size', targets: fileSizeColumn }
  ],
  "language": {
    "info": "Documents _START_-_END_ of _TOTAL_"
  }
});

$(table.api().table().container()).addClass('c-datatables');

$('.js-search-documents-title').on('keyup', function () {
  table.api().columns(titleColumn).search(this.value).draw();
});

$('.js-search-documents-type').on('change', function () {
  table.api().columns(typeColumn).search(this.value).draw();
});

$('.js-search-documents-department').on('change', function () {
  table.api().columns(departmentColumn).search(this.value).draw();
});

$('.js-search-documents-category').on('change', function () {
  table.api().columns(categoryColumn).search(this.value).draw();
});

$('.js-search-documents-year').on('change', function () {
  table.api().columns(yearColumn).search(this.value).draw();
});

// Clear button
$('.js-search-documents-clear').on('click', function() {
  table.api().columns().search('').draw();
});

// Jump to a section
const scrollSpeed = 400;
const subString = 1;

if (window.location.hash && $('.js-search-jump')) {
  const hash = window.location.hash.substring(subString);
  $('.js-search-jump').val(hash);
}

$('.js-search-jump').on('change', function () {
  const hash = this.value;
  $('html, body').animate({
    scrollTop: $('#' + hash).offset().top
  }, scrollSpeed, function() {
    window.location.hash = hash;
  });
});
